
export default {
  humidity : [
    {
      title: 'сухой',
      humidityZone : {
        'сухая' : 'А',
        'нормальная' : 'А',
        'влажная' : 'Б',
      }
    },
    {
      title: 'нормальный',
      humidityZone : {
        'сухая' : 'А',
        'нормальная' : 'Б',
        'влажная' : 'Б',
      }
    },
    {
      title: 'влажный/мокрый',
      humidityZone : {
        'сухая' : 'Б',
        'нормальная' : 'Б',
        'влажная' : 'Б',
      }
    }
  ]
}